import {
  GETMANUALDEPOSITLIST_SUCCESS,
  GETMANUALDEPOSITLIST_FAILED,
  RESET_GETMANUALDEPOSITLIST,
  LOADING_GETMANUALDEPOSITLIST,
  NETWORK_ERROR_GETMANUALDEPOSITLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetManualDepositList = () => {
  return { type: RESET_GETMANUALDEPOSITLIST };
};

const getManualDepositList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETMANUALDEPOSITLIST });
  await partnerServices
    .post("getManualDepositList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getManualDepositListsuccess(res.data));
          break;
        default:
          dispatch(getManualDepositListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETMANUALDEPOSITLIST, payload: err });
    });
};
function getManualDepositListsuccess(data) {
  return {
    type: GETMANUALDEPOSITLIST_SUCCESS,
    payload: data,
  };
}
function getManualDepositListFailed(data) {
  return {
    type: GETMANUALDEPOSITLIST_FAILED,
    payload: data,
  };
}

export { resetGetManualDepositList, getManualDepositList };
